import { IconCustomPaths } from "./customIcons/iconCustomPaths";
import { IconConfig } from "./types";
import { IconUpiPath } from "./upiIcons/IconUpiPath";

export const IconPaths: Record<string, IconConfig> = {
  // Icônes stroke existantes (toutes vos icônes actuelles)
  flag: {
    type: 'stroke' as const,
    viewBox: "0 0 24 24",
    paths: [
      "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528"
    ]
  },
  add: {
    type: 'stroke' as const,
    paths: ["M12 4v16m8-8H4"]
  },
  check: {
    type: 'stroke' as const,
    paths: ["M5 13l4 4L19 7"]
  },
  delete: {
    type: 'stroke' as const,
    paths: ["M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"]
  },
  search: {
    type: 'stroke' as const,
    paths: ["M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"]
  },
  edit: {
    type: 'stroke' as const,
    paths: ["M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"]
  },
  arrow: {
    type: 'stroke' as const,
    paths: ["M5 12h14", "M12 5l7 7-7 7"]
  },
  download: {
    type: 'stroke' as const,
    paths: ["M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"]
  },
  upload: {
    type: 'stroke' as const,
    paths: ["M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"]
  },
  menu: {
    type: 'stroke' as const,
    paths: ["M4 6h16M4 12h16M4 18h16"]
  },
  close: {
    type: 'stroke' as const,
    paths: ["M6 18L18 6M6 6l12 12"]
  },
  xmark: {
    type: 'stroke' as const,
    paths: ["M6 18L18 6M6 6l12 12"]
  },
  list: {
    type: 'stroke' as const,
    paths: ["M4 6h16M4 10h16M4 14h16M4 18h16"]
  },
  moreVertical: {
    type: 'stroke' as const,
    paths: ["M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"]
  },
  moreHorizontal: {
    type: 'stroke' as const,
    paths: ["M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"]
  },
  eye: {
    type: 'stroke' as const,
    paths: ["M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z", "M12 15a3 3 0 100-6 3 3 0 000 6z"]
  },
  mandate: {
    type: 'stroke' as const,
    paths: ["M8 12H9M16 12H12", "M16 8H15M12 8H8", "M8 16H13", "M3 14V10C3 6.22876 3 4.34315 4.17157 3.17157C5.34315 2 7.22876 2 11 2H13C16.7712 2 18.6569 2 19.8284 3.17157C20.4816 3.82476 20.7706 4.69989 20.8985 6M21 10V14C21 17.7712 21 19.6569 19.8284 20.8284C18.6569 22 16.7712 22 13 22H11C7.22876 22 5.34315 22 4.17157 20.8284C3.51839 20.1752 3.22937 19.3001 3.10149 18"]
  },
  documents: {
    type: 'stroke' as const,
    paths: ["M5 2a1 1 0 011-1h12a1 1 0 011 1v16a1 1 0 01-1 1h-12a1 1 0 01-1-1V2z", "M9 6h6M9 10h6M9 14h3"]
  },
  contract: {
    type: 'stroke' as const,
    paths: ["M4 4a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2h-12a2 2 0 01-2-2V4z", "M8 4v16M8 8h10M8 12h10M8 16h6", "M7 1v2M13 1v2M19 1v2"]
  },
  handshake: {
    type: 'stroke' as const,
    paths: ["M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2", "M8 12h8M7 16l2-2 2 2 2-2 2 2"]
  },
  home: {
    type: 'stroke' as const,
    paths: ["M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"]
  },
  settings: {
    type: 'stroke' as const,
    paths: ["M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z", "M15 12a3 3 0 11-6 0 3 3 0 016 0z"]
  },
  user: {
    type: 'stroke' as const,
    paths: ["M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"]
  },
  notification: {
    type: 'stroke' as const,
    paths: ["M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"]
  },
  calendar: {
    type: 'stroke' as const,
    paths: ["M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"]
  },
  heart: {
    type: 'stroke' as const,
    paths: ["M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"]
  },
  star: {
    type: 'stroke' as const,
    paths: ["M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"]
  },
  chevronDown: {
    type: 'stroke' as const,
    viewBox: "0 0 24 24",
    paths: ["M19 9l-7 7-7-7"]
  },
  chevronUp: {
    type: 'stroke' as const,
    viewBox: "0 0 24 24",
    paths: ["M5 15l7-7 7 7"]
  },
  chevronLeft: {
    type: 'stroke' as const,
    viewBox: "0 0 24 24",
    paths: ["M15 19l-7-7 7-7"]
  },
  chevronRight: {
    type: 'stroke' as const,
    viewBox: "0 0 24 24",
    paths: ["M9 5l7 7-7 7"]
  },
  info: {
    type: 'stroke' as const,
    paths: ["M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"]
  },
  warning: {
    type: 'stroke' as const,
    paths: ["M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"]
  },
  error: {
    type: 'stroke' as const,
    paths: ["M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"]
  },
  question: {
    type: 'stroke' as const,
    paths: ["M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"]
  },
  globe: {
    type: 'stroke' as const,
    paths: ["M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"]
  },
  mail: {
    type: 'stroke' as const,
    paths: ["M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"]
  },
  phone: {
    type: 'stroke' as const,
    paths: ["M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"]
  },
  location: {
    type: 'stroke' as const,
    paths: ["M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z", "M15 11a3 3 0 11-6 0 3 3 0 016 0z"]
  },
  lock: {
    type: 'stroke' as const,
    paths: ["M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"]
  },
  unlock: {
    type: 'stroke' as const,
    paths: ["M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"]
  },
  camera: {
    type: 'stroke' as const,
    paths: ["M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z", "M15 13a3 3 0 11-6 0 3 3 0 016 0z"]
  },
  image: {
    type: 'stroke' as const,
    paths: ["M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"]
  },
  share: {
    type: 'stroke' as const,
    paths: ["M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"]
  },
  bookmark: {
    type: 'stroke' as const,
    paths: ["M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"]
  },
  tag: {
    type: 'stroke' as const,
    paths: ["M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"]
  },
  lightning: {
    type: 'stroke' as const,
    paths: ["M13 10V3L4 14h7v7l9-11h-7z"]
  },
  chat: {
    type: 'stroke' as const,
    paths: ["M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"]
  },
  refresh: {
    type: 'stroke' as const,
    paths: ["M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"]
  },
  shield: {
    type: 'stroke' as const,
    paths: ["M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"]
  },
  trash: {
    type: 'stroke' as const,
    paths: ["M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"]
  },
  copy: {
    type: 'stroke' as const,
    paths: ["M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"]
  },
  history: {
    type: 'stroke' as const,
    paths: ["M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"]
  },
  cart: {
    type: 'stroke' as const,
    paths: ["M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"]
  },
  music: {
    type: 'stroke' as const,
    paths: ["M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"]
  },
  link: {
    type: 'stroke' as const,
    paths: ["M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"]
  },
  adjustments: {
    type: 'stroke' as const,
    paths: ["M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"]
  },
  moon: {
    type: 'stroke' as const,
    paths: ["M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"]
  },
  sun: {
    type: 'stroke' as const,
    paths: ["M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"]
  },
  laptop: {
    type: 'stroke' as const,
    paths: ["M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"]
  },
  desktop: {
    type: 'stroke' as const,
    paths: ["M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"]
  },
  mobile: {
    type: 'stroke' as const,
    paths: ["M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"]
  },
  logout: {
    type: 'stroke' as const,
    paths: ["M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"]
  },
  login: {
    type: 'stroke' as const,
    paths: ["M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"]
  },
  template: {
    type: 'stroke' as const,
    paths: ["M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"]
  },
  cube: {
    type: 'stroke' as const,
    paths: ["M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"]
  },
  save: {
    type: 'stroke' as const,
    paths: ["M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"]
  },
  print: {
    type: 'stroke' as const,
    paths: ["M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"]
  },
  clipboard: {
    type: 'stroke' as const,
    paths: ["M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"]
  },
  play: {
    type: 'stroke' as const,
    paths: ["M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z", "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"]
  },
  pause: {
    type: 'stroke' as const,
    paths: ["M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"]
  },
  stop: {
    type: 'stroke' as const,
    paths: ["M21 12a9 9 0 11-18 0 9 9 0 0118 0z", "M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"]
  },
  microphone: {
    type: 'stroke' as const,
    paths: ["M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"]
  },
  video: {
    type: 'stroke' as const,
    paths: ["M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"]
  },
  chart: {
    type: 'stroke' as const,
    paths: ["M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"]
  },
  grid: {
    type: 'stroke' as const,
    paths: ["M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"]
  },

  // Icônes complexes avec cercle
  umbrellaCircle: {
    type: 'complex' as const,
    viewBox: "0 0 35 35",
    elements: [
      { type: 'circle', cx: 17.496, cy: 17.496, r: 17.496 },
      { type: 'path', fill: '#fff', d: 'M22.794 17.087a1.49 1.49 0 0 1 1.162.89h.691a7.1 7.1 0 0 0-2.042-4.844 7.44 7.44 0 0 0-4.559-2.263.784.784 0 0 0-1.482 0 6.907 6.907 0 0 0-6.219 6.976 1 1 0 0 0 .014.131h.75a1.49 1.49 0 0 1 1.214-.89 1.32 1.32 0 0 1 1.255.89h.681a1.17 1.17 0 0 1 1.135-.884 1.19 1.19 0 0 1 1.172 1.121v4.067c0 .32 0 .829-.461.829a.5.5 0 0 1-.571-.55v-.732h-1.479v.732a1.986 1.986 0 0 0 2.063 2.087 2.05 2.05 0 0 0 1.5-.643 2.42 2.42 0 0 0 .464-1.722v-4.095c.069-.887.822-1.09 1.441-1.09a1.43 1.43 0 0 1 1.3.88h.7a1.34 1.34 0 0 1 1.271-.89' }
    ]
  },
  bienCircle: {
    type: 'complex' as const,
    viewBox: "0 0 34 34",
    elements: [
      { type: 'circle', cx: 17, cy: 17, r: 17 },
      { type: 'path', fill: '#fff', d: 'm16.749 13.449-6.076 5v5.4a.527.527 0 0 0 .527.527l3.693-.01a.527.527 0 0 0 .525-.527v-3.149a.527.527 0 0 1 .527-.527h2.109a.527.527 0 0 1 .527.527v3.152a.527.527 0 0 0 .53.524l3.691.01a.527.527 0 0 0 .527-.527v-5.4l-6.074-5a.4.4 0 0 0-.506 0m9.6 3.4-2.758-2.27v-4.564a.4.4 0 0 0-.4-.4h-1.84a.4.4 0 0 0-.4.4v2.393l-2.95-2.427a1.58 1.58 0 0 0-2.01 0l-8.338 6.869a.4.4 0 0 0-.053.557l.84 1.022a.4.4 0 0 0 .557.054l7.752-6.385a.4.4 0 0 1 .5 0l7.752 6.384a.4.4 0 0 0 .557-.053l.84-1.022a.4.4 0 0 0-.056-.558Z' }
    ]
  },
  coprorieteCircle: {
    type: 'complex' as const,
    viewBox: "0 0 35 35",
    elements: [
      { type: 'circle', cx: 17.496, cy: 17.496, r: 17.496 },
      { type: 'path', fill: '#fff', d: 'M22.936 23.244h-.513v-11.701a.616.616 0 0 0-.616-.616h-8.622a.616.616 0 0 0-.616.616v11.7h-.513a.31.31 0 0 0-.308.309v.513h11.5v-.513a.31.31 0 0 0-.312-.308m-7.903-10.367a.31.31 0 0 1 .308-.308h1.026a.31.31 0 0 1 .308.308v1.027a.31.31 0 0 1-.308.308h-1.026a.31.31 0 0 1-.308-.308Zm0 2.463a.31.31 0 0 1 .308-.308h1.026a.31.31 0 0 1 .308.308v1.027a.31.31 0 0 1-.308.308h-1.026a.31.31 0 0 1-.308-.308Zm1.334 3.8h-1.026a.31.31 0 0 1-.308-.313v-1.023a.31.31 0 0 1 .308-.308h1.026a.31.31 0 0 1 .308.308v1.023a.31.31 0 0 1-.308.311Zm1.95 4.106h-1.642v-2.157a.31.31 0 0 1 .308-.308h1.026a.31.31 0 0 1 .308.308Zm1.642-4.419a.31.31 0 0 1-.308.308h-1.026a.31.31 0 0 1-.308-.308v-1.023a.31.31 0 0 1 .308-.308h1.023a.31.31 0 0 1 .308.308Zm0-2.463a.31.31 0 0 1-.308.308h-1.026a.31.31 0 0 1-.308-.308v-1.023a.31.31 0 0 1 .308-.308h1.023a.31.31 0 0 1 .308.308Zm0-2.463a.31.31 0 0 1-.308.308h-1.026a.31.31 0 0 1-.308-.308v-1.024a.31.31 0 0 1 .308-.308h1.023a.31.31 0 0 1 .308.308Z' }
    ]
  },
  userCircle: {
    type: 'complex' as const,
    viewBox: "0 0 34 34",
    elements: [
      { type: 'circle', cx: 17, cy: 17, r: 17 },
      { type: 'path', fill: '#fff', d: 'M22.419 23.828a.746.746 0 0 1-.746-.746v-1.493a2.24 2.24 0 0 0-2.239-2.239h-5.225a2.24 2.24 0 0 0-2.239 2.239v1.493a.747.747 0 0 1-1.493 0v-1.493a3.73 3.73 0 0 1 3.732-3.731h5.224a3.736 3.736 0 0 1 3.731 3.731v1.493a.746.746 0 0 1-.745.746' },
      { type: 'path', fill: '#fff', d: 'M16.821 8.903a3.731 3.731 0 1 1-3.731 3.731 3.736 3.736 0 0 1 3.731-3.731m0 5.97a2.239 2.239 0 1 0-2.238-2.239 2.24 2.24 0 0 0 2.238 2.239' },
      { type: 'path', fill: '#fff', d: 'M24.658 17.859a.74.74 0 0 1-.528-.219l-1.493-1.493a.746.746 0 1 1 1.055-1.055l.965.965 2.462-2.457a.746.746 0 0 1 1.055 1.055l-2.985 2.985a.74.74 0 0 1-.531.219' }
    ]
  },

  // Icônes fill (votre pen original + PDF)
  pen: {
    type: 'fill' as const,
    paths: [
      "M5.25,15.9378906 L5.25,18.75 L8.06210943,18.75 L16.3559575,10.45615192 L13.5438481,7.64404249 L5.25,15.9378906 L5.25,15.9378906 L5.25,15.9378906 Z M18.5306555,8.28145396 C18.8231148,7.98899458 18.8231148,7.5165602 18.5306555,7.22410082 L16.7758992,5.46934454 C16.4834398,5.17688515 16.0110054,5.17688515 15.718546,5.46934454 L14.3462366,6.84165394 L17.1583461,9.65376337 L18.5306555,8.28145396 L18.5306555,8.28145396 L18.5306555,8.28145396 Z"
    ],
    viewBox: "0 0 24 24"
  },
  pdf: {
    type: 'fill' as const,
    paths: [
      "M6.988,12.297c0-0.646-0.449-1.032-1.241-1.032c-0.323,0-0.542,0.031-0.657,0.062v2.076c0.136,0.031,0.302,0.041,0.531,0.041C6.467,13.444,6.988,13.017,6.988,12.297z",
      "M11.890,11.286c-0.355,0-0.584,0.031-0.72,0.063v4.598c0.136,0.032,0.355,0.032,0.553,0.032c1.439,0.01,2.377-0.782,2.377-2.461C14.111,12.057,13.256,11.286,11.890,11.286z",
      "M21.282,8.585H20.706v-2.781c0-0.017-0.003-0.035-0.005-0.052c-0.001-0.11-0.036-0.219-0.112-0.305L15.962,0.161c-0.001-0.001-0.003-0.002-0.004-0.003c-0.028-0.031-0.06-0.056-0.094-0.079c-0.01-0.007-0.02-0.012-0.031-0.018c-0.029-0.016-0.061-0.029-0.093-0.039c-0.009-0.002-0.017-0.006-0.025-0.008C15.681,0.005,15.644,0,15.608,0H4.235c-0.519,0-0.941,0.422-0.941,0.941v7.643H2.718c-0.743,0-1.345,0.602-1.345,1.345v6.995c0,0.743,0.602,1.345,1.345,1.345h0.576V23.059c0,0.519,0.422,0.941,0.941,0.941h15.529c0.519,0,0.941-0.422,0.941-0.941V18.27h0.576c0.743,0,1.345-0.602,1.345-1.345v-6.995C22.627,9.187,22.025,8.585,21.282,8.585zM4.235,0.941h10.902v4.815c0,0.26,0.211,0.471,0.471,0.471h4.157v2.358H4.235V0.941zM15.789,13.465c0,1.345-0.49,2.273-1.169,2.847c-0.739,0.615-1.866,0.907-3.242,0.907c-0.824,0-1.407-0.052-1.804-0.104V10.212c0.584-0.094,1.345-0.146,2.148-0.146c1.334,0,2.199,0.24,2.878,0.751C15.33,11.359,15.789,12.224,15.789,13.465zM3.516,17.146V10.212c0.49-0.083,1.178-0.146,2.148-0.146c0.98,0,1.679,0.188,2.148,0.563c0.448,0.354,0.75,0.938,0.75,1.626c0,0.688-0.229,1.272-0.646,1.668c-0.542,0.511-1.345,0.741-2.283,0.741c-0.208,0-0.396-0.011-0.542-0.031v2.513H3.516V17.146zM19.765,22.804H4.235V18.27h15.529V22.804zM21.128,11.422h-2.701v1.606h2.523v1.293h-2.523v2.826h-1.594V10.118h4.296V11.422z"
    ],
    viewBox: "0 0 24 24"
  },
  document: {
    type: 'fill' as const,
    viewBox: "8 7 50 50",
    paths: [
      "M 20 10 C 16.686 10 14 12.686 14 16 L 14 48 C 14 51.314 16.686 54 20 54 L 44 54 C 47.314 54 50 51.314 50 48 L 50 28.65625 C 50 27.06425 49.367188 25.539062 48.242188 24.414062 L 35.585938 11.757812 C 34.459938 10.632812 32.93475 10 31.34375 10 L 20 10 z M 20 14 L 30 14 L 30 24 C 30 27.314 32.686 30 36 30 L 46 30 L 46 48 C 46 49.105 45.105 50 44 50 L 20 50 C 18.895 50 18 49.105 18 48 L 18 16 C 18 14.895 18.895 14 20 14 z M 34 15.828125 L 44.171875 26 L 36 26 C 34.895 26 34 25.105 34 24 L 34 15.828125 z M 24 34 C 22.896 34 22 34.895 22 36 C 22 37.105 22.896 38 24 38 L 40 38 C 41.104 38 42 37.105 42 36 C 42 34.895 41.104 34 40 34 L 24 34 z M 24 42 C 22.896 42 22 42.895 22 44 C 22 45.105 22.896 46 24 46 L 40 46 C 41.104 46 42 45.105 42 44 C 42 42.895 41.104 42 40 42 L 24 42 z"
    ]
  },
  ...IconUpiPath,
  ...IconCustomPaths,
} as const satisfies Record<string, IconConfig>;

export type IconName = keyof typeof IconPaths;
